import styled from "styled-components"
import Spinner from "components/EvtKit/loading-spinner/LoadingSpinner"
import { CellText } from "components/EvtKit/list-items/CellText"
import { CellActionButtons } from "components/EvtKit/list-items/CellActionButtons"
import { useAppSelector } from "reducers/store"
import { useCallback } from "react"
import { useNavigate } from "react-router-dom"

const ListItemsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-height: 100%;
  gap: 16px;
  padding-right: 24px;
  margin-top: 24px;
`

const ListItemsContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 16px;
  border-radius: 8px;
  background: #fff;
  background-color: ${(props) => props.theme.palette.white};
  box-shadow: 0px 2px 6px 0px rgba(13, 10, 44, 0.08);
`

interface ApiMappingListProps {
  openModal: (index: number) => void
}

const ApiMappingList = (props: ApiMappingListProps) => {
  const { openModal } = props

  const navigate = useNavigate()

  const { data, loading } = useAppSelector((state) => state.apiMapping.apiMappingList)

  const handleClickEdit = useCallback((item) => {
    navigate(`/api-mappings/${item._id}`)
  }, [])

  return (
    <ListItemsContainer>
      {loading && <Spinner />}
      {!loading &&
        data?.map((item, index) => (
          <ListItemsContent key={index}>
            <CellText title="Nome" content={item.name} />
            <CellText title="Rota" content={item.path} />
            <CellText title="Método HTTP" content={item.method} />
            <CellText title="Produto" content={item.productName} />
            <CellActionButtons onClickEdit={() => handleClickEdit(item)} onDelete={() => openModal(index)} />
          </ListItemsContent>
        ))}
    </ListItemsContainer>
  )
}

export default ApiMappingList
